import angular from 'angular';

class editRelationCtrl {
  /* @ngInject */
  constructor() {}

  $onInit() {
    this.seller = this.resolve.seller;
    this.relation = this.resolve.relation;
  }

  close() {
    this.modalInstance.dismiss('close');
  }
}

angular.module('app.principal').component('editRelation', {
  templateUrl: require('./modal-relation.html'),
  controller: editRelationCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
